import { useState } from "react";
import DynamicFormComponent from "../DynamicForm/DynamicForm";
// import { useLocation } from "react-router-dom";
import DynamicReport from "../DynamicReport/DynamicReport";
// import { EditOutlined, HistoryOutlined } from "@ant-design/icons";
import InterfaceComponent from "../../Pages/Masters/InterfaceComponent";
// import { message } from "antd";
// import {
//   ActionHandlerProvider,
//   useActionHandler,
// } from "../ActionHandlerContext";

import {
  ActionHandlerProvider,
  useActionHandler,
} from "../../Components/ActionHandlerContext";

export default function DynamicMaster({ ...props }) {
  // const location = useLocation();
  // const { state } = location;
  const [type, setType] = useState<string>("");
  const [formRId, setFormRId] = useState<number>(0);
  const [hideBtn, setHideBtn] = useState<boolean>(true);
  const [mode, setMode] = useState("");

  // const handleCreate = (Type: string, RId: number) => {
  //   setHideBtn(false);
  //   setType(Type);
  //   setFormRId(RId);
  //   setMode("Create");
  // };

  const handleCancel = () => {
    setHideBtn(true);
  };

  // const handleActionClick = (actionType: string, record: any) => {
  //   console.log(`${actionType} clicked`, record);
  //   if (actionType === "Edit") {
  //     setHideBtn(false);
  //     setType(actionType);
  //     setFormRId(record.key);
  //     setMode("Edit");
  //   } else {
  //     message.warning("Are you sure ??");
  //   }
  // };

  const { rowActionHandler, reportActionHandler } = useActionHandler();
  const childRowHandlers = {
    ...rowActionHandler, // Merge Parent's rowActionHandler
    DynamicMasterRowEdit:
      rowActionHandler?.DynamicMasterRowEdit ||
      ((actionType, record) => {
        console.log(`Child handling ${actionType} for record:`, record);
        setHideBtn(false);
        setType(actionType);
        setFormRId(record.key);
        setMode("Edit");
      }),
  };
  const childReportHandlers = {
    ...reportActionHandler,
    DynamicReportActionCreate:
      reportActionHandler?.DynamicReportActionCreate ||
      ((actionType, ...params: any[]) => {
        console.log(`Child handling ${params} for record:`, params[0]);
        setHideBtn(false);
        setType(actionType);
        setFormRId(0);
        setMode("Create");
        return true;
      }),
  };

  return (
    <>
      {hideBtn ? (
        <ActionHandlerProvider
          rowActionHandler={childRowHandlers}
          reportActionHandler={childReportHandlers}
        >
          <DynamicReport
            // handleCreate={handleCreate}
            id={props?.id}
            dashboardId={props?.dashboardId}
          />
        </ActionHandlerProvider>
      ) : (
        // <DynamicFormComponent
        //   id={state?.id || id || 0} // Default to 0 if state.id is not available
        //   actionType={type}
        //   RId={formRId}
        //   Mode={mode}
        //   handleCancel={handleCancel}
        // />
        <InterfaceComponent
          id={props?.id || 0} // Default to 0 if state.id is not available
          actionType={type}
          RId={formRId}
          Mode={mode}
          handleCancel={handleCancel}
        />
      )}
    </>
  );
}
